export default __webpack_public_path__ + "static/media/ele_example_4_1.c8510fa9.png";